import router from '@/router'
import firebase from 'firebase/app';
import 'firebase/auth';
import format from 'date-fns/format'
import axios from 'axios'
export default {
    namespaced: true,
    state: {
      error: null,
      loading: false,
      user:null,
      userbeforelogin:null,
      activeIndex:'1',
      useremail:'',
      companyData: null,
      errorip:'',
      pagePermission: null,
    },
    mutations: {
      errorMessage (state:any, error:any) {
        state.error = error
      },
      loadingStatus(state:any, loading:boolean) {
        state.loading = loading
      },
      setUserLogin (state:any, user:any) {
        state.user = user
      },
      setActiveIndex(state:any, value:string){
        state.activeIndex = value
      },
      setUserEmail(state:any, value:string){
        state.useremail = value
      },
      setErrorIP(state:any, value:string){
        state.errorip = value
      },
      setUserBeforeLogin(state:any, user:any){
        state.userbeforelogin = user
      },
      setCompanyData(state:any, user:any){
        state.companyData = user
      },
      setPagePermission(state:any, data:any){
        state.pagePermission = data
      },
    },
    actions: {
      setUserLogin ({commit}:any){
        const userData:any = localStorage.getItem('userData')
        if(userData){
          try {
            commit('setUserLogin', JSON.parse(atob(userData) || '{}'))
          } catch (error) {
            firebase.auth().signOut()
            localStorage.removeItem('userData')
            commit('setUserLogin', null)
            router.replace('/login')
          }
        }
      },
      logout ({commit, dispatch}:any) {

        if(window.navigator && navigator.serviceWorker) {
          navigator.serviceWorker.getRegistrations()
          .then(function(registrations) {
            for(let registration of registrations) {
              registration.unregister();
            }
          });
        }
      
        /*save logs*/
        const userData:any = localStorage.getItem('userData')
        let user = JSON.parse(atob(userData))
        dispatch('authen/addLogs', {
          createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          status: 'logout',
          user: user.email
        }, {root:true}).then(function() {
          firebase.auth().signOut()

          localStorage.removeItem('userData')
          commit('setUserLogin', null)

          router.replace('/login')
        });
      },
      clearError ({commit}:any) {
        commit('errorMessage', null)
      },
      async getCompanyData ({commit, dispatch}:any, authData:any) {
        const company = (await firebase.database().ref(`/company/${authData.company}`).once('value')).val()
        commit('setCompanyData', company)
      },
      pagePermission({commit}:any) {
        const pagePermission = {
          insights: {
            user: false,
            admin: false,
            hr: true,
            leadership: true,
            superleader: true,
            superadmin: true,
          },
          members: {
            user: false,
            admin: true,
            hr: true,
            leadership: false,
            superleader: true,
            superadmin: true,
          },
          questions: {
            user: false,
            admin: true,
            hr: true,
            leadership: false,
            superleader: true,
            superadmin: true,
          },
          rewards: {
            user: false,
            admin: true,
            hr: true,
            leadership: false,
            superleader: true,
            superadmin: true,
          },
          power_ups: {
            user: false,
            admin: true,
            hr: true,
            leadership: false,
            superleader: true,
            superadmin: true,
          },
          sparks: {
            user: false,
            admin: true,
            hr: true,
            leadership: false,
            superleader: true,
            superadmin: true,
          },
          happily_village: {
            user: false,
            admin: true,
            hr: true,
            leadership: false,
            superleader: true,
            superadmin: true,
          },
          reports: {
            user: false,
            admin: true,
            hr: true,
            leadership: false,
            superleader: true,
            superadmin: true,
          },
          integrations: {
            user: false,
            admin: true,
            hr: true,
            leadership: false,
            superleader: true,
            superadmin: true,
          },
          billing: {
            user: false,
            admin: true,
            hr: true,
            leadership: false,
            superleader: true,
            superadmin: true,
          },
          settings: {
            user: false,
            admin: true,
            hr: true,
            leadership: false,
            superleader: true,
            superadmin: true,
          },
        }
        commit('setPagePermission', pagePermission);
      },
      async addLogs({ commit, rootState, dispatch }: any, object: any){
        let ip = '';
        const url = 'https://api.ipify.org?format=json'
        await axios.get(url).then(response => {
          ip = response.data.ip
        })
        .catch(function (error) {
            console.log(error);
        });
        object.ip = ip;
        await firebase.firestore().collection('logs').add(object);
        return true;
      }
    },
    getters: {
        user : (state:any) => {
          return state.user
        },
        error : (state:any) => {
            return state.error
        },
        loading: (state:any) => {
          return state.loading
        },
        checkLogin: (state:any) => {
          return (state.user)?true:false
        },
        activeIndex: (state:any) => {
          return state.activeIndex
        },
        useremail: (state:any) => {
          return state.useremail
        },
        companyData: (state:any) => {
          return state.companyData
        },
        errorip: (state:any) => {
          return state.errorip
        },
        pagePermission: (state:any) => {
          return state.pagePermission
        },
    }
  }

function dispatch(arg0: string) {
  throw new Error('Function not implemented.');
}
